import { style } from 'typestyle'
export const pt40 = style({ paddingTop: '40px' })
